// removed by extract-text-webpack-plugin
module.exports = {"card":"styles__card___2zyVX","name":"styles__name___1ONZY","icon":"styles__icon___1HTHq"};


//////////////////
// WEBPACK FOOTER
// ./src/views/search/today-card/styles.css
// module id = 1141
// module chunks = 0